//@ts-nocheck
import React, { useState, useEffect, useRef } from 'react'
import { formatDistanceStrict } from 'date-fns';
import { debounce } from 'lodash';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { _baseRequest, COMMON } from '../../utils/baseApi';
import { useNavigate, useParams } from 'react-router-dom';
import { getColorForLabel } from '../../utils/colorUtils';
import JobMessageSection from '../jobApplicationDetails/JobMessageSection';
import { fetchDocument } from '../../features/job/jobSlices';
import { useAppDispatch } from '../../app/hooks';
import { ExclamationIcon } from '../icons';
import { fetchJobPipelineDetailsData } from '../../features/hiringpipeline/hiringPipelineSlice';
import JobScorecardsSection from '../jobApplicationDetails/JobScorecardsSection';
import ReviewOverview from '../jobApplicationDetails/candidateReview/ReviewOverview';
import { fetchApplicationByDetails } from '../../features/ApplicationData/ApplicationDataSlice';
import ApplicationQuestionnaireSection from '../jobApplicationDetails/Questionnaire/ApplicationQuestionnaireSection';
import MeetingSection from '../jobApplicationDetails/ApplicationMeeting/MeetingSection';
import AppReviewSection from '../jobApplicationDetails/ApplicationAppReview/AppReviewSection';
import LoadingBar from 'react-top-loading-bar'

const InboxDetails = [
  { id: 'all', name: 'All' },
  { id: 'questionnaire', name: 'Questionnaire' },
  { id: 'meeting', name: 'Meeting' },
  { id: 'review', name: 'Review' },
  { id: 'stage', name: 'Stage' },
];

function Updates() {
  const [activeTab, setActiveTab] = useState(null);
  const [activeTab1, setActiveTab1] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [allActivityItem, setAllActivityItem] = useState({
    activitys: [],
    totalActivitys: 0,
    currentPage: 1,
    hasNextPage: false,
    limit: 25,
    totalPages: 1
  });
  const [isLoading, setIsLoading] = useState(false);
  const [shouldLoadMore, setShouldLoadMore] = useState(false);

  const { baseId, jobId, applicationId } = useParams<{ baseId: string; jobId: string; applicationId: string; }>();
  const listRef = useRef(null);
  const handleMouseOver = () => setIsHovered(true);
  const handleMouseOut = () => setIsHovered(false);;
  const [selected, setSelected] = useState(InboxDetails[0])
  const loginUserId = localStorage.getItem("userAuthId");
  const { activitys } = allActivityItem;


  const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const navigate = useNavigate();
  const [activeMessageType, setActiveMessageType] = useState(null);
  const [app, setApp] = useState('')
  const [jobStatus, setJobStatus] = useState('')
  const dispatch = useAppDispatch();
  const [firstTab, setFirstTab] = useState(null)
  const [pipelineStageDataUser, setPipelineStageDataUser] = useState([])
  const [selectedItem, setSelectedItem] = useState(null);

  const [applicationDetails, setapplicationDetails] = useState('')
    const loadingBarRef = useRef(null);
  // const applicationId = jobApplication?.id


  useEffect(() => {
    if (applicationId || activeTab) {
      const fetchJob = async () => {
        try {
          const res = await dispatch(fetchApplicationByDetails({ baseId: Number(baseId), jobId: jobId, applicationId: applicationId || activeTab })).unwrap();
          if (res.status === 200) {
            setapplicationDetails(res?.data);
          }
        } catch (error) {
          console.error("Error fetching base member details:", error);
        }
      };
      fetchJob();
    }
  }, [applicationId, dispatch, activeTab, jobId, baseId]);

  const handleSelectionChange = (item) => {
    setSelected(item);

    // Set active message type based on selection
    switch (item.id) {
      case 'scorecard':
        setActiveMessageType('scorecard');
        break;
      case 'stage':
        setActiveMessageType('stage');
        break;
      case 'questionnaire':
        setActiveMessageType('questionnaire');
        break;
      case 'meeting':
        setActiveMessageType('meeting');
        break;
      case 'review':
        setActiveMessageType('review');
        break;
      default:
        setActiveMessageType(null);
    }
  };



  function classNames(...classes: any) {
    return classes.filter(Boolean).join(' ')
  }


  const loadMoreActivities = async () => {
    if (allActivityItem.hasNextPage && !isLoading && shouldLoadMore) {
      setIsLoading(true);
      try {

        const nextPage = allActivityItem.currentPage + 1;
        let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/activity.listActivitys?page=${nextPage}&limit=${allActivityItem.limit}`;


        // // Add message type to the URL if a specific type is selected
        // if (activeMessageType && activeMessageType !== 'all') {
        //   fullUrl += `&type=${activeMessageType}`;
        // }

        if (jobId) {
          fullUrl += `&job_id=${jobId}`;
        }



        const response = await _baseRequest(fullUrl, 'GET');

        if (response.status === 200 && response.data.activitys && response.data.activitys.length > 0) {
          setAllActivityItem(prevState => ({
            ...response.data,
            activitys: [...prevState.activitys, ...response.data.activitys],
          }));
        } else {
          setAllActivityItem(prevState => ({
            ...prevState,
            hasNextPage: false,
          }));
        }
      } catch (error) {
        console.error("Error fetching more activities:", error);
      } finally {
        setIsLoading(false);
        setShouldLoadMore(false);
      }
    }
  };


  const debouncedHandleScroll = debounce(() => {
    if (listRef.current && allActivityItem.hasNextPage && !isLoading) {
      const { scrollTop, scrollHeight, clientHeight } = listRef.current;
      if (scrollHeight - scrollTop <= clientHeight * 1.5) {
        setShouldLoadMore(true);
      }
    }
  }, 200);


  useEffect(() => {
    if (shouldLoadMore) {
      loadMoreActivities();
    }
  }, [shouldLoadMore]);


  useEffect(() => {
    const fetchInitialData = async () => {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/activity.listActivitys?page=1&limit=${allActivityItem.limit}`;

      // Add message type to the URL if a specific type is selected
      if (activeMessageType && activeMessageType !== 'all') {
        fullUrl += `&activity_type=${activeMessageType}`;
      }

      if (jobId) {
        fullUrl += `&job_id=${jobId}`;
      }

      try {
        setIsLoading(true);
        loadingBarRef.current?.continuousStart();
        const response = await _baseRequest(fullUrl, 'GET');
        if (response?.data?.activitys && response?.data?.activitys?.length > 0) {

          setAllActivityItem(response?.data);
          setActiveTab(response?.data?.activitys[0].app_id);
          setActiveTab1(response?.data?.activitys[0].job_id)
          setActiveMessageType(response?.data?.activitys[0].activity_type);
          setFirstTab(response?.data?.activitys[0]);
          setSelectedItem(response?.data?.activitys[0]);
        } else {
          setAllActivityItem({
            activitys: [],
            totalActivitys: 0,
            currentPage: 1,
            hasNextPage: false,
            limit: 25,
            totalPages: 1
          });
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setIsLoading(false);
        loadingBarRef.current?.complete();
      }
    };

    if (baseId) {
      fetchInitialData();
    }
  }, [baseId, selected, jobId]);


  const getShortFormTimeAgo = (createdAt) => {
    const timeAgo = formatDistanceStrict(new Date(createdAt), new Date(), {
      addSuffix: true,
      includeSeconds: true,
    });

    const shortFormTimeAgo = timeAgo
      .replace(/ hours?/, ' hrs')
      .replace(/ minutes?/, ' mins')
      .replace(/ seconds?/, ' secs')
      .replace(/ days?/, ' days')
      .replace(/ months?/, ' mon')
      .replace(/ years?/, ' yrs');

    const cleanedTimeAgo = shortFormTimeAgo
      .replace(/\sago$/, '')
      .replace(/^about\s/, '');

    return cleanedTimeAgo;
  };


  const getSenderDetails = (item) => {
    if (item.user_id) {
      const senderUser = baseMembers.find(member => member.user_id === item.user_id) || {};
      return {
        image: senderUser.profile_pic || null,
        name: senderUser.name || null
      };
    }

    // If user_id is null, use app details
    if (item.app_name) {
      return {
        image: null,
        name: item.app_name.split(' ')[0] // First word of app_name
      };
    }

    // If app_name is also null, use app_email
    return {
      image: null,
      name: item.app_email || 'Unknown'
    };
  };


  const handleTabClick = (item) => {

    setApp(item)
    // Update the active tab and message type
    setActiveTab(item.app_id);
    setActiveTab1(item.job_id);
    setActiveMessageType(item.activity_type);
    setSelectedItem(item);

    // Navigate based on message type
    switch (item.activity_type) {
      case 'scorecard':
        navigate(`/${baseId}/job/${item.job_id}/activity/app/${item.app_id}`);
        break;
      case 'stage':
        navigate(`/${baseId}/job/${item.job_id}/activity/app/${item.app_id}`);
        break;
      case 'questionnaire':
        navigate(`/${baseId}/job/${item.job_id}/activity/app/${item.app_id}`);
        break;
      case 'meeting':
        navigate(`/${baseId}/job/${item.job_id}/activity/app/${item.app_id}`);
        break;
      case 'review':
        navigate(`/${baseId}/job/${item.job_id}/activity/app/${item.app_id}`);
        break;
      default:
        navigate(`/${baseId}/job/${item.job_id}/activity/app/${item.app_id}`);
    }
  }




  // Render the appropriate section based on message type
  const renderMessageSection = () => {
    const selectedItem = activitys.find(app => app.app_id === activeTab);
    if (!selectedItem) {
      return <div className='w-full mt-0 flex justify-center items-center flex-col gap-y-3' style={{ height: 'calc(100vh - 144px)' }}>
        <ExclamationIcon />
        <p className='text-[#0000007a] text-[13px]'>Nothing here</p>
      </div>;
    }

    const { activity_type: messageType, job_id: jobId, app_id: appId } = selectedItem;

    const renderSectionTitle = (title: string) => (
      <>
      <div className='flex items-center gap-x-2'>
          <div className='w-5 h-5 flex items-center justify-center'>
          {/* {index} */}
          {title.activity_type === "scorecard" &&
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-scoreboard w-[1rem] h-[1rem] text-[#808080]"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
              <path d="M12 5v2" />
              <path d="M12 10v1" />
              <path d="M12 14v1" />
              <path d="M12 18v1" />
              <path d="M7 3v2" />
              <path d="M17 3v2" />
              <path d="M15 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z" />
              <path d="M6 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5" />
            </svg>

          }
          {title.activity_type === "questionnaire" &&
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-notebook w-[1rem] h-[1rem] text-[#808080]"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18" />
              <path d="M13 8l2 0" />
              <path d="M13 12l2 0" />
            </svg>

          }

          {title.activity_type === "meeting" &&
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-calendar text-[#808080] w-[1rem] h-[1rem]"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
              <path d="M16 3v4" />
              <path d="M8 3v4" />
              <path d="M4 11h16" />
              <path d="M11 15h1" />
              <path d="M12 15v3" />
            </svg>


          }

          {title.activity_type === "review" &&
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-devices-check w-[1rem] h-[1rem] text-[#808080]"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4" />
              <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7" />
              <path d="M16 9h2" />
              <path d="M15 19l2 2l4 -4" />
            </svg>

          }

          {title.activity_type === "stage" &&
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-brand-walmart  w-[1rem] h-[1rem] text-[#808080]"
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 8.04v-5.04" />
              <path d="M15.5 10l4.5 -2.5" />
              <path d="M15.5 14l4.5 2.5" />
              <path d="M12 15.96v5.04" />
              <path d="M8.5 14l-4.5 2.5" />
              <path d="M8.5 10l-4.5 -2.505" />
            </svg>

          }
        </div>


        <h2 className="text-[14px] lg:text-[14px] font-normal leading-5 text-[#1b1b1b] tracking-[-0.01rem] capitalize">
          {title.message}
        </h2>
      </div>
      
        <div className="bg-[#e0e0e0] w-full h-[1px] mt-4 mb-8" />
      </>
    );

    switch (activeMessageType) {
      case 'scorecard':
        return (
          <div>
            {renderSectionTitle(selectedItem || 'Scorecard')}
            <JobScorecardsSection job={jobId} app={appId} />
          </div>
        );
      case 'stage':
        return <div>
          {renderSectionTitle(selectedItem || 'Stage')}
          <ReviewOverview applicationDetails={applicationDetails} setapplicationDetails={setapplicationDetails} />
        </div>
      case 'questionnaire':
        return <div>
          {renderSectionTitle(selectedItem || 'Questionnaire')}
          <ApplicationQuestionnaireSection job={jobId} app={appId} />
        </div>
      case 'meeting':
        return <div>
          {renderSectionTitle(selectedItem || 'Meeting')}
          <MeetingSection job={jobId} app={appId} />
        </div>
      case 'review':
        return <div>
          {renderSectionTitle(selectedItem || 'Review')}
          <AppReviewSection job={jobId} app={appId} applicationDetails={applicationDetails?.application} setapplicationDetails={setapplicationDetails}/>
        </div>
      default:
        return <div>
          {renderSectionTitle(selectedItem || 'Messages')}
          <JobMessageSection job={jobId} app={appId} />
        </div>
    }
  };


  useEffect(() => {
    if (jobId && baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem('jobPostDetailsData');
        if (storedBase) {
          setJobStatus(JSON.parse(storedBase));
        } else {
          try {
            const baseResponse = await dispatch(fetchDocument({ baseId, id: jobId }));
            setJobStatus(baseResponse?.payload.data);
            localStorage.setItem('jobPostDetailsData', JSON.stringify(baseResponse?.payload.data));
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [dispatch, jobId, baseId]);

  const handleApplicationDetails = (id) => {
    navigate(`/${baseId}/job/${jobId}/app/${id?.app_id}/overview`);
  }

  useEffect(() => {
    if (baseId && jobId) {
      const fetchTeams = async () => {
        try {
          const baseMembersDetailsString = localStorage.getItem('jobByHiringTeamMembers');

          let baseMembers: any[] = [];
       

          if (baseMembersDetailsString) {
            const hiringTeamMembers = JSON.parse(baseMembersDetailsString) || [];

            const userList = hiringTeamMembers.map((member: any) => {
              return {
                id: member.user_id,
                name: member?.name || 'Unknown User',
                profile_pic: member?.profile_pic || null
              };
            }).filter(user => user.name !== 'Unknown User');

            setPipelineStageDataUser(userList);
          } else {
            const baseResponse = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: parseInt(baseId),
                JobId: jobId
              })
            );

            const teamMemberData = baseResponse?.payload?.data?.teamMembers;
            // local stroage
            localStorage.setItem('jobByHiringTeamMembers', JSON.stringify(teamMemberData))
            if (!teamMemberData) {
              console.warn("No teamMember data returned from API.");
              return;
            }

            const hiringTeamMembers = Array.isArray(teamMemberData) ? teamMemberData : [];

            const userList = hiringTeamMembers.map((member: any) => {
              return {
                id: member.user_id,
                name: member?.name || 'Unknown User',
                profile_pic: member?.profile_pic || null
              };
            }).filter(user => user.name !== 'Unknown User');

            setPipelineStageDataUser(userList);
          }
        } catch (error) {
          console.error("Error fetching team members:", error);
        }
      };

      fetchTeams();
    }
  }, [baseId, jobId, dispatch]);



  return (
    <div className="h-[calc(100vh_-62px)] flex justify-start items-start data-inbox-feedback ring-1 lg:ring-zinc-950/5 shadow-xs  rounded-tl-none rounded-tr-lg rounded-bl-none rounded-br-lg overflow-x-auto">
     <LoadingBar color="#ff591e" ref={loadingBarRef} />
     <div className='flex flex-1 flex-col min-w-0 h-full'>
        <div className='flex  flex-row flex-1  overflow-y-hidden'>
          <div className={`flex flex-col min-h-0 ${isSidebarOpen ? 'mq767:min-w-full mq1023:min-w-[350px] mq3000:min-w-[350px] mq767:max-w-full mq1023:max-w-[350px] mq3000:max-w-[350px]' : ' min-w-0 max-w-0'} transition-all duration-300 ease-in-out`}>



            <div className="fixed top-0 sidebar-fixed sm:w-full" style={{ zIndex: 9 }}>

              <div className='flex items-center'>
                {/* <div className="flex h-[56px] w-[351px] border-r  border-solid border-gray-100 shrink-0 items-center gap-x-4 bg-white px-4 shadow-custom-1 sm:gap-x-6 sm:px-6 lg:px-4">
                  <div className="h-6 w-px bg-gray-900/10 lg:hidden" aria-hidden="true" />
                  <span className='text-black-100 font-semibold text-sm capitalize line-clamp-1'>  {jobId && jobStatus?.job_title}</span>


                  <div className='flex flex-1 justify-end'>

                    <Listbox value={selected} onChange={handleSelectionChange}>
                      <div className="relative z-10">
                        <ListboxButton className="relative w-[110px] rounded-md bg-white py-1.5 px-[10px] text-left text-gray-900
focus:outline-none  text-[14px] sm:leading-4 border border-solid border-[#e7e7e8] font-medium cursor-pointer">
                          <div className='flex items-center gap-1.5 justify-between'>
                            <span className="block truncate">{selected.name}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                              <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                          </div>
                        </ListboxButton>
                        <ListboxOptions className="absolute z-10 mt-[9px] left-[-80px] bg-white max-w-[191.05px] min-w-[191.05px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 
">
                          {InboxDetails.map((item) => (
                            <ListboxOption
                              key={item.id}
                              value={item}
                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                  'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                )
                              }
                            >
                              <span className="block truncate font-normal">{item.name}</span>
                            </ListboxOption>
                          ))}
                        </ListboxOptions>
                      </div>
                    </Listbox>


                  </div>


                </div> */}


              </div>
            </div>
            <div className='flex items-center justify-between w-full pl-6 pr-[15px]'>
              <span className='h-[52px]  flex items-center font-semibold text-sm'>Activity</span>
              <div className='flex flex-1 justify-end'>

                <Listbox value={selected} onChange={handleSelectionChange}>
                  <div className="relative z-10">
                    <ListboxButton className="relative w-[110px] rounded-md bg-white py-1.5 px-[10px] text-left text-gray-900
focus:outline-none  text-[14px] sm:leading-4 border border-solid border-[#e7e7e8] font-medium cursor-pointer">
                      <div className='flex items-center gap-1.5 justify-between'>
                        <span className="block truncate">{selected.name}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4">
                          <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                        </svg>
                      </div>
                    </ListboxButton>
                    <ListboxOptions className="absolute z-10 mt-[9px] left-[-80px] bg-white max-w-[191.05px] min-w-[191.05px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                      {InboxDetails.map((item) => (
                        <ListboxOption
                          key={item.id}
                          value={item}
                          className={({ active }) =>
                            classNames(
                              active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                              'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                            )
                          }
                        >
                          <span className="block truncate font-normal">{item.name}</span>
                        </ListboxOption>
                      ))}
                    </ListboxOptions>
                  </div>
                </Listbox>
              </div>
            </div>

            <div className='bg-[#e0e0e0] w-full h-[1px]'></div>
            <div
              ref={listRef}
              className={isHovered ? 'inbox-height-activity overflowing-element hovered flex-1 p-0 mt-[0px]' : 'inbox-height-activity overflowing-element mt-[0px]'}
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
              onScroll={debouncedHandleScroll}
            >
              <div className='m-auto min-h-full max-w-[80em]'>
                <ul className='  max-w-full md:max-w-[343px] lg:max-w-[343px] h-full p-[8px]'>

                  {isLoading && activitys.length === 0 ? (
                    <div className="flex items-center justify-center h-[calc(100vh_-_75px)] w-full">
                      <div className="simple-spinner-loader">
                        <span></span>
                      </div>
                    </div>
                  ) : (
                    // Your existing list rendering code
                    activitys.map((item, index) => {
                      const cleanedTimeAgo = getShortFormTimeAgo(item.created_at);
                      const { image, name } = getSenderDetails(item);



                      return (
                        <div className='' key={index}>
                          <div className='sm:block hidden'>
                            <li key={item.app_id} className='flex flex-row items-center justify-between text-sm p-0'
                              onClick={() => handleTabClick(item)}
                            >
                              <div
                                className={`flex flex-row items-center justify-between flex-1 rounded-[0.375rem] mb-1
                                     cursor-pointer px-2 py-3 hover:bg-gray-100 ${item.id === selectedItem?.id ? 'bg-gray-100 ' : index == 0 ? 'bg-transparent' : 'bg-transparent'}`}
                              >
                                {/* {index} */}
                                <div className='px-2 w-full h-full gap-2 flex flex-col gap-y-2'>
                                  <div className='flex items-center flex-row gap-2'>
                                    <div className='w-5 h-5 flex items-center justify-center'>
                                      {/* {index} */}
                                      {item.activity_type === "scorecard" &&
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-scoreboard w-[1rem] h-[1rem] text-[#808080]"
                                        >
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
                                          <path d="M12 5v2" />
                                          <path d="M12 10v1" />
                                          <path d="M12 14v1" />
                                          <path d="M12 18v1" />
                                          <path d="M7 3v2" />
                                          <path d="M17 3v2" />
                                          <path d="M15 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z" />
                                          <path d="M6 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5" />
                                        </svg>

                                      }
                                      {item.activity_type === "questionnaire" &&
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-notebook w-[1rem] h-[1rem] text-[#808080]"
                                        >
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18" />
                                          <path d="M13 8l2 0" />
                                          <path d="M13 12l2 0" />
                                        </svg>

                                      }

                                      {item.activity_type === "meeting" &&
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-calendar text-[#808080] w-[1rem] h-[1rem]"
                                        >
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
                                          <path d="M16 3v4" />
                                          <path d="M8 3v4" />
                                          <path d="M4 11h16" />
                                          <path d="M11 15h1" />
                                          <path d="M12 15v3" />
                                        </svg>


                                      }

                                      {item.activity_type === "review" &&
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-devices-check w-[1rem] h-[1rem] text-[#808080]"
                                        >
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4" />
                                          <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7" />
                                          <path d="M16 9h2" />
                                          <path d="M15 19l2 2l4 -4" />
                                        </svg>

                                      }

                                      {item.activity_type === "stage" &&
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth={2}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-brand-walmart  w-[1rem] h-[1rem] text-[#808080]"
                                        >
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M12 8.04v-5.04" />
                                          <path d="M15.5 10l4.5 -2.5" />
                                          <path d="M15.5 14l4.5 2.5" />
                                          <path d="M12 15.96v5.04" />
                                          <path d="M8.5 14l-4.5 2.5" />
                                          <path d="M8.5 10l-4.5 -2.505" />
                                        </svg>

                                      }
                                    </div>
                                    <div className='line-clamp-1 text-[13px] text-[#000000EB]'>


                                      {item.message}


                                      {/* {
                                        item.activity_type === "file" ? `attachment -  ${item.msg_message} ` : item.msg_message
                                      } */}
                                    </div>
                                    <span dateTime={item.created_at} className='text-dark-black-200 text-[13px] flex-shrink-0 ml-auto'>{cleanedTimeAgo}</span>
                                  </div>

                                  <div className='flex items-center flex-row gap-2'>
                                    <div className=''>
                                      {
                                        image ? (
                                          <img
                                            src={`${process.env.REACT_APP_API_BASE_URL}/${image}`}
                                            alt={`${'Profile'}`}
                                            className="h-5 w-5 flex-none rounded-full ring-1 ring-gray-900/10"
                                          />
                                        ) : (
                                          <div style={{ backgroundColor: getColorForLabel(name?.charAt(0) || item.app_name || item.app_email) }}
                                            className="w-5 h-5 rounded-full flex items-center justify-center">
                                            <span className="font-medium text-white mt-[0px]"
                                            >{name?.charAt(0) || item.app_name.charAt(0) || item.app_email.charAt(0)}</span>
                                          </div>
                                        )
                                      }

                                    </div>
                                    <div className='overflow-hidden flex-1 '>
                                      <div className='flex items-center flex-row gap-[0px]'>
                                        <p className='text-dark-black-200 overflow-hidden text-ellipsis line-clamp-1  text-[13px]'>
                                          {name || item.app_name || item.app_email}
                                        </p>
                                        {
                                          item.app_headline &&
                                          <div className='text-dark-black-200 overflow-hidden text-ellipsis line-clamp-1 flex-1 text-[13px]  items-center flex '>
                                            <span className='mx-[6px] w-[1px] h-[12px] bg-gray-400 block' ></span>
                                            <div className='text-dark-black-200 overflow-hidden text-ellipsis line-clamp-1 text-[13px]'> {item.app_headline}</div>
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>

                                </div>

                              </div>
                            </li>
                          </div>
                          <div className='sm:hidden block'>
                            <li key={item.id} className='flex flex-row items-center justify-between text-sm p-0'

                              onClick={() => handleTabClick(item.app_id)}
                            >
                              <div
                                className={`flex flex-row items-center justify-between flex-1 cursor-pointer px-2 py-3 hover:bg-[#0000000a] ${index === 0 ? 'bg-light-gray-300' : 'bg-transparent'
                                  }`}                                            >
                                <div className='px-2 w-[1.5rem] self-start'>
                                  <div
                                    className={`mt-[4px] focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm w-[9px] 
           h-[9px] rounded-full border flex justify-center items-center`}

                                  ></div>
                                </div>

                                <div
                                  className={`flex flex-row items-center justify-between flex-1 cursor-pointer px-2 py-3 hover:bg-[#0000000a] ${index === 0 ? 'bg-light-gray-300' : 'bg-transparent'
                                    }`}                                            >
                                  <div className='px-2 w-[1.5rem] self-start'>
                                    <div
                                      className={`mt-[6px] focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm w-[9px] 
               h-[9px] rounded-full border flex justify-center items-center`}

                                    ></div>
                                  </div>

                                  <div className='px-2 flex-1 text-dark-black-100 flex flex-col gap-[2px]'>
                                    <div className='flex items-center flex-row gap-2'>

                                      <p className='overflow-hidden text-ellipsis line-clamp-1 text-[13px]'>
                                        {item.app_name}
                                      </p>
                                      <span dateTime={item.created_at} className='text-dark-black-200 text-[13px] flex-shrink-0 ml-auto'>{cleanedTimeAgo}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </div>

                        </div>
                      )
                    })
                  )}

                  {isLoading && activitys.hasNextPage &&
                    <div className=" flex items-center justify-center relative z-50 h-[25px]">
                      <div className="simple-spinner-loader">
                        <span></span>
                      </div>
                    </div>
                  }
                  {!isLoading && !activitys.hasNextPage && activitys.length === 0 && (
                    <div className='w-full mt-0 flex justify-center items-center flex-col gap-y-3' style={{ height: 'calc(100vh - 75px)' }}>
                      <ExclamationIcon />
                      <p className='text-[#0000007a] text-[13px]'>Nothing here</p>
                    </div>
                  )}
                </ul>

              </div>



            </div>


          </div>
          <div className=' border-l border-b-0 border-gray-200 w-full border-t-0 mt-[0px] min-w-[800px]'>
            <div className=' shrink-0 items-center gap-x-4 bg-white px-4 border-b border-solid border-[#e0e0e0] h-[53px] sm:gap-x-6 sm:px-6 lg:px-4 rounded-tr-lg'>
              <div className="flex items-center mx-2 gap-2 py-2  justify-between">
                <div className='flex items-center gap-2'>
                  {app ?
                    <>

                      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400">
                        {app?.app_name?.charAt(0) || app?.app_email?.charAt(0)}
                      </div>
                      <div className='flex flex-col gap-y-[1px]'>
                        <span className="text-black-100 font-semibold text-sm capitalize line-clamp-1">
                          {app?.app_name}
                        </span>
                        <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1 w-[255px]">
                          {app?.app_email}
                        </span>
                      </div>
                    </>
                    : firstTab &&
                    <>

                      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] font-medium text-white capitalize bg-gray-400">
                        {firstTab?.app_name?.charAt(0) || firstTab?.app_email?.charAt(0)}
                      </div>
                      <div className='flex flex-col gap-y-[1px]'>
                        <span className="text-black-100 font-semibold text-sm capitalize line-clamp-1">
                          {firstTab?.app_name}
                        </span>
                        <span className="text-[#1b1b1b] leading-4 text-[12px] font-normal line-clamp-1 w-[255px]">
                          {firstTab?.app_email}
                        </span>
                      </div>
                    </>
                  }
                </div>

                <button
                  onClick={() => handleApplicationDetails(app ? app : firstTab)}

                  className="rounded-md  duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                  style={{
                    transitionProperty:
                      "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform"
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    data-slot="icon"
                    className="w-[1.1em] h-[1.1em] text-[#000]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                    />
                  </svg>
                </button>
              </div>

            </div>
            <div className='flex-1 flex flex-col py-[34px] lg:py-[32px] px-0 lg:px-10 overflow-auto h-[calc(100vh_-_120px)] mb-5'>
              <div className='px-[2px] sm:px-6 lg:px-8 w-full'>
                <div className='max-w-full md:max-w-[710px] lg:max-w-[710px] m-auto'>
                  {renderMessageSection()}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Updates